const type = 'CLOSE_MODAL';

const closeModal = () => ({
  type,
});

export { type };
export default closeModal;
